import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@Components/Button';

export default class MultiInputPill extends React.PureComponent {
  render() {
    const { value, onRemove, disabled } = this.props;

    return (
      <span
        className={classnames(['els-multi-input-pill', {
          'disabled': disabled,
        }])}
      >
        <span className="els-multi-input-pill-text" title={value}>{value}</span>
        <Button
          buttonConfig={{
            type: 'link',
            size: 'xs',
            ariaLabel: 'Delete',
            className: 'els-multi-input-pill-delete-button',
            e2eName: 'delete-multi-input-pill',
          }}
          iconConfig={{ name: 'delete', size: 'tiny', className: 'els-multi-input-pill-delete-icon' }}
          onClick={onRemove}
          disabled={disabled}
        />
        </span>
    );
  }
}

MultiInputPill.propTypes = {
  value: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
